<template>
  <div class="component" style="position:fixed;top: 0;left:0;background-color:white;z-index: 10000;height: 35px;width:100%;" v-if="$store.state.isDebugging">
    <b>Tid:
    {{ time }}
    {{ seconds }}
  </b>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import moment from 'moment';
import TimeoutModal from '@/components/modals/TimeoutModal';
import API from '@/classes/API';

export default {
  props: {
    cancelPath: {
      default: '/',
    },
  },
  components: {
    TimeoutModal,
  },
  data() {
    return {
      seconds: 0,
      intervalRef: null,
      intervalRef2: null,
      showTimeoutModal: false,
      time: '',
      lastActive: null,
      touchSeconds: 14,
      pendingRequest: false,
    };
  },
  created() {
    window.addEventListener('click', this.setLastActive);
    window.addEventListener('keyup', this.setLastActive);

    this.lastActive = new Date();
    this.touchOrder();

    this.touchSeconds = this.SITE_CONFIG.timeout.touch;

    this.intervalRef = setInterval(this.calculate_time, 1000);
    this.intervalRef2 = setInterval(this.touchOrder, (this.touchSeconds * 1000));
  },
  destroyed() {
    window.removeEventListener('click', this.setLastActive);
    window.removeEventListener('keyup', this.setLastActive);

    clearInterval(this.intervalRef);
    clearInterval(this.intervalRef2);
  },
  mounted() {
  },
  computed: {
    currentlyPaying() {
      return this.$route.name === 'payment';
    },
    activeLock() {
      return this.$store.state.lockingActive;
    },
  },
  methods: {
    ...mapMutations([
      'clearCart',
      'openModal',
      'openTimeoutModal',
      'closeTimeoutModal',
      'closeModal',
      'closeAllModals',
      'saveCartLocking',
    ]),
    setLastActive() {
      const diff = moment().diff(moment(this.lastActive), 'seconds');
      if (diff >= (this.touchSeconds + 5) && diff > 0 && this.seconds > 0) {
        this.doTheTouch();
      }

      this.lastActive = new Date();
    },
    touchOrder() {
      const diff = moment().diff(moment(this.lastActive), 'seconds');
      if (diff < this.touchSeconds && this.seconds > 0) {
        this.doTheTouch();
      }
    },
    async doTheTouch() {
      this.pendingRequest = true;

      const order = this.$route.query.order;
      const orderCode = this.$route.query.code;
      const { code, before_time } = await API.post(`extend-time/${this.$store.state.lockingCode}?order=${order}&code=${orderCode}`);

      this.saveCartLocking({
        code,
        beforeTime: before_time,
      });

      this.pendingRequest = false;
    },
    calculate_time() {
      if (!this.activeLock) {
        return false;
      }

      this.seconds = moment.utc(`${this.$store.state.lockingBeforeTime}`, 'YYYY-MM-DD HH:mm:ss').diff(moment(), 'seconds') - 2;

      let showTimeoutSeconds = this.SITE_CONFIG.timeout.lock_show;

      if (this.currentlyPaying) {
        showTimeoutSeconds = this.SITE_CONFIG.timeout.lock_show_payment;
      }

      if (this.seconds <= showTimeoutSeconds && this.seconds > 0
        && !this.pendingRequest) {
        this.showWarning();
      }

      if (this.seconds <= 0 && !this.pendingRequest) {
        // clearInterval(this.intervalRef);
        this.tryAgain();
      }

      let m = 0;
      let s = 0;

      if (this.seconds >= 60) {
        m = Math.floor(this.seconds / 60);
        s = this.seconds - (m * 60);
      } else {
        m = 0;
        s = this.seconds;
      }

      if (m < 10) {
        if (!m) {
          m = 0;
        } else {
          m = `0${m}`;
        }
      }
      if (s < 10) {
        s = `0${s}`;
      }

      this.time = `${m}:${s}`;

      this.$emit('update', this.seconds);

      return true;
    },
    secondsFunction() {
      return this.seconds;
    },
    showWarning() {
      const $this = this;

      this.openTimeoutModal(['TimeoutModal', {
        seconds: this.secondsFunction,
        cancel: () => {
          $this.closeTimeoutModal();
        },
        continue: this.resetTimerAndClose,
        inactive: () => true,
        zIndex: 100015,
      }]);
    },
    resetTimerAndClose() {
      this.touchOrder();
      this.closeTimeoutModal();
    },
    tryAgain() {
      if (!this.$store.state.lockingActive) {
        return false;
      }

      this.closeAllModals();
      this.closeTimeoutModal();

      const props = {};

      if (this.currentlyPaying || this.$route.name === 'payment') {
        props.forceSyncAll = true;
      }

      setTimeout(() => {
        this.openModal(['BookingCancelled', props]);
      }, 1);

      this.$store.state.lockingActive = false;

      return true;
    },
  },
};
</script>

<style lang="stylus" scoped>
.component
  position: fixed
  bottom 0
  right 0
  background-color white
  padding 10px 10px
  border-top-left-radius: 5px
  z-index 10
</style>



// WEBPACK FOOTER //
// WebFooter.vue?7050055f